import React from 'react';
import { IIconProps } from './utils';

export const BackToTop = ({
  fill = 'currentColor',
  height = 30,
  width = 30,
  ...rest
}: IIconProps) => (
  <svg
    fill="none"
    height={height}
    viewBox="0 0 30 30"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M15 22.5L15 12.5M15 12.5L11.875 15.625M15 12.5L18.125 15.625M22.75 7.5L7.5 7.5"
      stroke={fill}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
